/* eslint-disable react-hooks/exhaustive-deps */
/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-07-19 11:39:10
 *
 *******************************************************/
// @flow
import _ from 'lodash';
import React from 'react';
import { withI18n } from '@shopify/react-i18n';
import { Heading, Layout, Card } from '@shopify/polaris';
import StarRatings from 'react-star-ratings';

import { Carousel } from 'src/components/views/common/carousel';

import { REVIEWS } from 'src/constants/ai-landing-page';

const Reviews = props => {
  const { i18n } = props;

  return (
    <Layout.Section>
      <div className="section-header">
        <Heading>{i18n.translate('AdminHTML.LandingPage.AIPowered.review_Title')}</Heading>
      </div>
      <div className="section-content reviews-slideshow">
        <Carousel
          items={_.map(REVIEWS, (review, index) => (
            <Card key="index">
              <div className="review-header">
                <span>{review.name}</span>
                <span>
                  <StarRatings
                    rating={review.stars}
                    starRatedColor="#FFBD13"
                    starHoverColor="#FFBD13"
                    starDimension="1rem"
                    // changeRating={this.changeRating}
                    numberOfStars={5}
                    name="rating"
                    starSpacing={'0'}
                  />
                </span>
              </div>
              <div className="review-time">{review.time}</div>
              <div className="review-content">{review.review}</div>
            </Card>
          ))}
          autoDisplay={true}
          alwaysShowSlide={true}
          autoHeight={true}
        />
      </div>
    </Layout.Section>
  );
};

export default withI18n()(Reviews);
